import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/** 路由加载占位与新版概览卡片、趋势和分布布局保持一致 */
export function OverviewSkeleton() {
  return (
    <div className="flex min-w-0 flex-col gap-6" aria-label="数据概览加载中">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-9 w-56 max-w-full" />
        <Skeleton className="h-5 w-56 max-w-full" />
      </div>
      <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-5">
        {Array.from({ length: 5 }, (_, index) => (
          <Card
            key={index}
            className={
              index === 0
                ? 'min-h-[148px] gap-3 py-5 sm:col-span-2 xl:col-span-1'
                : 'min-h-[148px] gap-3 py-5'
            }
          >
            <CardHeader className="flex items-center gap-2.5 px-5">
              <Skeleton className="size-7 shrink-0 rounded-lg" />
              <Skeleton className="h-5 w-20" />
            </CardHeader>
            <CardContent className="flex flex-col gap-3 px-5">
              <Skeleton className="h-7 w-32 max-w-full" />
              <Skeleton className="h-3 w-28 max-w-full" />
            </CardContent>
          </Card>
        ))}
      </div>
      {[0, 1].map((row) => (
        <div
          key={row}
          className={
            row === 0
              ? 'grid min-w-0 gap-6 xl:grid-cols-[minmax(0,2fr)_minmax(340px,1fr)]'
              : 'grid min-w-0 gap-6 xl:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)]'
          }
        >
          {[0, 1].map((column) => (
            <Card key={column} className="min-w-0 gap-5 py-5 shadow-none">
              <CardHeader className="flex flex-wrap items-center justify-between gap-3 px-5">
                <Skeleton className="h-6 w-28" />
                <Skeleton className="h-9 w-48 max-w-full" />
              </CardHeader>
              <CardContent className="flex flex-col gap-5 px-5">
                <Skeleton className="h-7 w-40" />
                <Skeleton className="h-[280px] w-full" />
              </CardContent>
            </Card>
          ))}
        </div>
      ))}
    </div>
  );
}
